// extracted by mini-css-extract-plugin
export default {"buttonOpen":"AddCustomerButton_buttonOpen__M70Bz","triggerContainer":"AddCustomerButton_triggerContainer__5onwq"};